import React from 'react'
import styled, { css } from 'styled-components'
import { DeleteOutline } from '@material-ui/icons'

import { Spacings, Text } from '@styles'

import Button from '../../basic/Button'

const CardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_3B};
	padding: ${Spacings.SPACING_4B};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.lg};
	background: ${({ theme }) => theme.colors.surface.card};
	transition: border-color 0.15s ease-in-out;

	${({ hoverable, theme }) =>
		hoverable &&
		css`
			cursor: pointer;
			&:hover {
				border-color: ${theme.colors.brand.primary};
			}
		`}

	${({ selected, theme }) =>
		selected &&
		css`
			border-color: ${theme.colors.brand.primary};
		`}
`

const TopRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_2B};
`

const Actions = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_2B};
`

const AddressId = styled.span`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_400};
	color: ${({ theme }) => theme.colors.text.secondary};
`

const AddressText = styled.p`
	margin: 0;
	font-size: ${Text.BASE_SMALL};
	line-height: 1.5;
	font-weight: ${Text.BOLD_400};
	color: ${({ theme }) => theme.colors.text.secondary};
`

const CityText = styled(AddressText)`
	margin-top: ${Spacings.SPACING_2};
	font-size: ${Text.TINY_SMALL};
	font-weight: ${Text.BOLD_600};
`

const AddressBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};
`

// Presentational address card. No API calls here — the parent passes onEdit / onDelete.
const AddressCard = ({ data, onEdit, onDelete, selected = false, hoverable = false, disabled }) => {
	const cityLine = data ? `${data?.city}, ${data?.state} - ${data?.pincode}` : ''

	return (
		<CardWrapper selected={selected} hoverable={hoverable}>
			<TopRow>
				<AddressId>{`Address Id : ${data?.address_id ?? 'N/A'}`}</AddressId>
				{onDelete && (
					<Actions>
						<Button type='button' variant='ghost' color='danger' onClick={onDelete} disabled={disabled} aria-label='Delete address'>
							<DeleteOutline fontSize='small' />
						</Button>
					</Actions>
				)}
			</TopRow>

			<AddressBlock>
				{data?.complete_address && <AddressText>{data?.complete_address}</AddressText>}
				{cityLine && <CityText>{cityLine}</CityText>}
			</AddressBlock>
		</CardWrapper>
	)
}

export default AddressCard
